import * as customEtl from './customEtl.js';
import * as customField from './customFieldMap.js';
import * as del from './delete.js';
import * as list from './list.js';
import * as customCatalog from './customCatalog.js';
import * as updateConfig from './updateConfig.js';

export const tenants = [customEtl, customField, del, list, customCatalog, updateConfig];
